/* eslint-disable max-len */
import { CompanyAPI } from '@api';

const acceptCreditOperation = async (id, checkboxes) => {
  const params = {
    lending_id: id,
    accepted: true,
    checkboxes,
  };

  return CompanyAPI.acceptOrRejectCreditOperation(params)
    .then(({ data }) => data)
    .catch((error) => Promise.reject(error.response));
};

export { acceptCreditOperation };
